<div
  class="practice-users-container"
  [class.in-modal]="isUserModalOpen"
  *ngIf="isTranslationLoaded"
>
  <div class="practice-users-header-row">
    <div class="users-info">
      <span class="users-label">
        {{ "reportingV2.USER_LABEL" | transloco }}
      </span>
      <div>
        <span class="users-count">
          {{ filteredData.length }} {{ "reportingV2.TOTAL_LABEL" | transloco }}
        </span>
      </div>
    </div>

    <div class="status-filter">
      <qai-searchable-select
        [options]="engagementStatuses"
        [placeholder]="'reportingV2.ENGAGEMENT_STATUS_LABEL' | transloco"
        [shape]="'rectangle'"
        [multiselect]="true"
        [selectionPrefix]="
          'reportingV2.ENGAGEMENT_STATUS_PREFIX_LABEL' | transloco
        "
        (valueChange)="onStatusValueChange($event)"
        [value]="selectedStatuses"
        (itemSelected)="onEngagementStatusSelected($event)"
        [scopedOptionsSelectionMode]="scopedOptionsSelectionMode"
      ></qai-searchable-select>
    </div>

    <div class="header-actions">
      <qai-field [label]="''">
        <qai-icon kind="search" qaiSlot="startIcon" />
        <input
          qai-input
          type="text"
          [value]="searchTerm"
          placeholder="{{ 'reportingV2.SEARCH_FOR_A_USER_LABEL' | transloco }}"
          (input)="onSearchChange($event)"
        />
      </qai-field>

      <button class="icon-button" (click)="onDownloadIconClick()">
        <qai-icon [kind]="'download'" [size]="'20px'"></qai-icon>
      </button>

      <button class="icon-button" (click)="toggleModal()">
        <qai-icon
          [kind]="isUserModalOpen ? 'x-close' : 'expand'"
          size="'20px'"
        ></qai-icon>
      </button>
    </div>
  </div>
  <div *ngIf="isLoading" class="loading-container">
    <qai-loading size="medium"></qai-loading>
  </div>

  <qai-table
    *ngIf="!isLoading"
    [headers]="headers"
    [data]="filteredData"
    [currentPage]="currentPage"
    [pageSize]="pageSize"
    [noDataMessage]="getEmptyStateMessage()"
    (cellClick)="onCellClick($event)"
    (pageChanged)="pageChanged($event)"
    (sortChanged)="onSortChanged($event)"
    [isTooltipLoading]="isTooltipLoading"
    (tooltipDataRequested)="onTooltipDataRequested($event)"
  >
  </qai-table>
</div>
